<h2 mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center">
    <span>{{ 'nav.bcm.myCustomizations' | translate }}</span>
    <button mat-icon-button (click)="close()" [matTooltip]="'common.close' | translate">
        <mat-icon>close</mat-icon>
    </button>
</h2>

<mat-dialog-content>
    <bcm-settings-navigation></bcm-settings-navigation>
</mat-dialog-content>
